module.exports = __webpack_public_path__ + "static/media/PizzaPizzaBanner.e33796f7.png";